exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body {\n\theight: 100%;\n\tmargin: 0;\n}\n\nbody { \n\tdisplay: flex; \n\tflex-direction: column; \n}\n\n.footer {\n\tfont-size: 16px;\n\tpadding: 20px;\n\tmargin-top: auto; \n}\n\n", ""]);

// exports
